var Sushi;

(function (Sushi) {
	"use strict";

	/** @type {HTMLFormElement} */
	var fileForm = document.querySelector("#portfolioFile");

	/** @type {HTMLFormElement} */
	var listForm = document.querySelector("#portfolioList");

	/**
	 * @param {Element} textEl The validation text placeholder
	 * @param {string} message
	 * @return {void}
	 */
	function validate(textEl, message) {
		textEl.classList.remove("_red");
		textEl.classList.add("_success");
		textEl.innerText = message;
	}

	/**
	 * @param {Element} textEl The validation text placeholder
	 * @param {string} message
	 * @return {void}
	 */
	function invalidate(textEl, message) {
		textEl.classList.remove("_success");
		textEl.classList.add("_red");
		textEl.innerText = message;
	}

	/**
	 * @param event
	 * @return {void}
	 */
	function handleFileSubmit(event) {
		if (!fileUpload.files.length) {
			event.preventDefault();

			fileUpload.dropArea.classList.add("c-input--validationError");
			invalidate(
				fileValidationEl,
				"You need to choose one portfolio file to upload."
			);
		}
	}

	/**
	 * @param event
	 * @return {void}
	 */
	function handleListSubmit(event) {
		event.preventDefault();
		Sushi.Dom.removeClass(listInput.parentNode, "c-input--validationError");

		if (listInput.value) {
			validate(
				listValidationEl,
				"The CUSIP/CINS/ISIN issue identifiers are valid. Results are being downloaded."
			);
		}
		else {
			Sushi.Dom.addClass(listInput.parentNode, "c-input--validationError");
			invalidate(
				listValidationEl,
				"The CUSIP/CINS/ISIN issue identifier asdf must be 8, 9 or 12 characters."
			);
		}
	}

	if (fileForm) {
		var fileValidationEl = fileForm.querySelector("[data-form-validation]");
		var fileUploadContainer = fileForm.querySelector("[data-plugin=FileUpload]");
		var fileUpload = Sushi.getPluginInstance(Sushi.Plugins.FileUpload, fileUploadContainer);

		Sushi.Events(fileForm).on("submit", handleFileSubmit);
		Sushi.Events(fileUpload.inputPlaceHolder).on("FileUpload.change", function () {
			fileValidationEl.innerText = "";
			Sushi.Dom.removeClass(fileUpload.dropArea, "c-input--validationError");
		});
	}

	if (listForm) {
		var listValidationEl = listForm.querySelector("[data-form-validation]");
		var listInput = listForm.querySelector("textarea");

		Sushi.Events(listForm).on("submit", handleListSubmit);
		Sushi.Events(listInput).on("change", function () {
			listValidationEl.innerText = "";
			Sushi.Dom.removeClass(listInput.parentNode, "c-input--validationError");
		});
	}

})(Sushi || (Sushi = {}));
